import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { SupabaseService } from './services/supabase.service';
import { ThemeService } from './services/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  constructor(
    private readonly supabaseService: SupabaseService,
    private readonly themeService: ThemeService,
  ) {
    this.supabaseService.init();
    this.themeService.init();
  }
}
